/* eslint-disable  */
import { useEffect, useState, useMemo, useCallback } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import { MenuItem, TextField, Tooltip } from '@mui/material';
import moment from 'moment';
import SelectPicker from 'rsuite/SelectPicker';
import { Settings } from '@mui/icons-material';
import FlowChart from './FlowChart/FlowChart';
import ProcessFlowMiddleContainer from './ProcessFlowMiddleContainer';
import styles from './ProcessFlowPage.module.scss';
import {
	addCommas,
	addCommasOnly,
	classes,
	formatQuantityWithLakhsCrores,
	useQuery,
} from '../../Helpers';
import { ProcessModal } from '../../Components/Modals/ProcessModal';
import { analyticsAction, formActions, modalActions, navigationActions } from '../../Actions';
import processFlowServices from '../../Services/Analytics Services/process-flow.services';
import { notificationServices } from '../../Services';
import DatePickerCustom from '../../Components/DatePickerCustom/DatePickerCustom';
import { POItemsModal } from '../../Components/Modals/POItemsModal';
import { AlertModal, ProductionPlanModal } from '../../Components/Modals';
import inventoryAnalyticsServices from '../../Services/Analytics Services/inventory-analytics.services';
import BackdropLoader from '../../Components/Loaders/BackdropLoader';
import drawerActions from '../../Actions/drawer.actions';
// eslint-disable-next-line import/no-unresolved, import/extensions
import ProcessSettingsDrawer from '@/Components/Drawers/ProcessSettingsDrawer/ProcessSettingsDrawer';
import DisplayStoreView from './DisplayStoreView/DisplayStoreView';
import assetServices from '@/Services/AssetServices/asset.services';
import { ImageModal } from '@/Components/Modals/ImageModal';
import EditNodeModal from '@/Components/Modals/EditNodeModal/EditNodeModal';
import { Button } from '@/Components/ui/button';
import { useAuth } from '@/Components/Auth/Login/auth';
import { DatePicker, Progress } from 'rsuite';
import ProgressCard from '@/Components/progerssCard';
import view from '@/Images/view.png';
import OutletModal from '@/Components/Modals/OutletModal/outletModal';
import { urls } from '@/Constants';
import { BarChart3, Calculator, PackageOpen, RefreshCcw, Weight } from 'lucide-react';
import issued from '@/Images/issued.svg';
import restaurantIssued from '@/Images/res_issued.svg';
import produced from '@/Images/produced.svg';
import primaryPackaged from '@/Images/primaryPack.svg';
import secondaryPackaged from '@/Images/secondaryPack.svg';
import dispatched from '@/Images/externalDispatch.svg';
import wastage from '@/Images/wastage.svg';
import {
	notShowToggleButtonstoCusotmer,
	operationSummaryDynamicPageAllowedCustomer,
} from '@/config/config';
import { CustomModal } from '@/Components/Modals/CustomModal';
// import NodeTypes from './NodeTypes/NodeTypes';

const upperShiftWiseStatsName = {
	ISSUED: 'Issued Value',
	PRODUCED: 'Produced Value',
	DISPATCHED: 'Distribution Value',
	INDENT: 'Restaurant Indent',
};

const tabs = [
	{
		id: 'weight',
		label: 'Weight',
		icon: <Weight size={12} />,
	},
	{
		id: 'cost',
		label: 'Cost',
		icon: '₹',
	},
	{
		id: 'count',
		label: 'Count',
		icon: <Calculator size={12} />,
	},
];

function ProcessFlowPage(props) {
	const {
		userPermissions,
		toggleProcessModal,
		// toggleProductionPlanModal,
		stores,
		fetchStoresList,
		togglePOItemsModal,
		toggleProcessSetting,
		toggleImageModal,
		toggleEditNodeModal,
		toggleAlert,
		collapseSidebar,
		sidebarCollapsed,
	} = props;
	const query = useQuery();
	const store = JSON.parse(query.get('store'));
	const date = JSON.parse(query.get('dateOnly'));
	const shiftId = JSON.parse(query.get('shiftId'));
	const { appConfig = {} } = useAuth();
	const isDanachogaCustomer =
		appConfig?.customerId === 70 || appConfig?.customerId === 67;
	const isA2bCustomer = appConfig?.customerId === 68;
	const [loading, setLoading] = useState(false);
	const [isEdit, setIsEdit] = useState(false);
	const [shiftList, setShiftList] = useState([]);
	const [productionPlanLoading, setProductionPlanLoading] = useState(false);
	const [isChanged, setIsChanged] = useState(false);
	const { userConfig = {} } = useAuth();
	const { level } = userConfig?.userDetails || {};
	const [productId, setProductId] = useState(null);
	const dispatch = useDispatch();
	const [selectedBatches, setSelectedBatches] = useState([]);
	const [isProductJourneyActive, setIsProductJourneyActive] = useState(false);

	const [availableProductionPlans, setAvailableProductionPlans] = useState(
		[]
	);
	const [selectedStore, setSelectedStore] = useState(null);
	const [selectedTab, setSelectedTab] = useState('weight');
	const [state, setState] = useState({
		selectedDate: new Date(),
		selectedPlan: -1,
		selectedTimeType: 'WORK_ORDER',
		// selectedTimeType: isDanachogaCustomer
		// 	? 'WORK_ORDER'
		// 	: 'PRODUCTION_PLAN',
	});
	const [initialState, setInitialState] = useState({
		nodes: [],
		edges: [],
	});
	const [nodesState, setNodesState] = useState({
		nodes: [],
		edges: [],
	});
	const [immovableAssetsList, setImmovableAssetsList] = useState([]);
	// new states
	const [selectedShift, setSelectedShift] = useState(null);
	const [retailSelectedStore, setRetailSelectedStore] = useState(null);
	const [upperShiftStats, setUpperShiftStats] = useState([]);
	const [bottomDayStats, setBottomDayStats] = useState([]);
	const [selectedRetailOrderStats, setSelectedRetailOrderStats] = useState({
		orderIds: [],
		statsSummary: {
			fulfillmentPercent: 0,
		},
	});
	const [hideShift, setHideShift] = useState(false);
	const [fullMode, setFullMode] = useState(false);
	const [refresh, setRefresh] = useState(false);
	const [viewType, setViewType] = useState('STORE');
	const isInternal = userPermissions?.INTERNAL;

	useEffect(() => {
		if (shiftList?.length > 0) {
			if (shiftId && ![-999, '-999'].includes(shiftId)) {
				setSelectedShift(shiftId);
			} else {
				setSelectedShift(shiftList?.[0]?.id);
			}
		}
	}, [shiftList]);


	const fetchImmovableAssets = async () => {
		setLoading(true);
		const data = {
			store: selectedStore,
		};
		try {
			const response = await assetServices.storeAssetInfo({
				data,
			});
			if (response?.responseCode === 'SS-001') {
				notificationServices.generateNotification({
					type: 'success',
					message: response?.responseMessage,
				});
				setImmovableAssetsList(response?.data);
			}
		} catch {
			// eslint-disable-next-line no-console
			console.log('error');
		} finally {
			setLoading(false);
		}
	};

	const fetchShiftList = async (store) => {
		try {
			const response = await inventoryAnalyticsServices.fetchShifts({
				params: {
					storeId: store,
				},
			});
			if (response?.statusCode === 200) {
				setShiftList([
					{ id: -999, shiftName: 'All' },
					...(response?.data || []),
				]);
			}
		} catch (error) {
			console.log(error);
		}
	};

	useEffect(() => {
		// if (isDanachogaCustomer) {
		// 	setHideShift(true);
		// 	return;
		// }
		if (selectedStore) {
			const baseStore =
				stores?.find((store) => store?.id === selectedStore)?.type ===
				'RETAIL';
			setHideShift(baseStore);
			fetchImmovableAssets();
			fetchShiftList(selectedStore);
		}
	}, [selectedStore]);

	useEffect(() => {
		setIsEdit(true);
	}, [isInternal]);

	const fetchStatsSummary = async () => {
		setLoading(true);
		const response = await processFlowServices?.fetchStatsSummary({
			data: {
				period: {
					startDate: formattedDate,
					endDate: formattedDate,
				},
			},
		});
		if (response?.statusCode === 200) {
			return response?.data;
		}
		setLoading(false);
	};

	const fetchNodes = async () => {
		setLoading(true);
		try {
			if (!selectedStore) {
				return;
			}
			const response = await processFlowServices?.fetchNodes({
				params: {
					storeId: selectedStore,
				},
			});
			if (response?.statusCode === 200) {
				const { nodes, edges } = response?.data ?? {};
				const stats = await fetchAnalytics();
				// const statsSummary = isDanachogaCustomer ? await fetchStatsSummary() : null;
				// if (isDanachogaCustomer) {
				// 	setUpperShiftStats(statsSummary);
				// } else {
				setUpperShiftStats(stats?.shiftStats);
				// }
				setInitialState({
					nodes: nodes?.map?.((ele) => {
						return {
							...ele,
							id: ele?.id?.toString(),
							type: 'customNode',
							displayOrder: ele?.displayOrder ?? 0,
							data: {
								...ele?.data,
								bgColor:
									ele?.data?.type?.toLowerCase() ===
										'operation'
										? '#FFEDD5'
										: '#DBEAFE',
								stats: {
									displayValue:
										stats?.nodesStat[ele?.id?.toString()]
											?.stats?.statsDisplay ?? {},
									percentageValue:
										stats?.nodesStat[ele?.id?.toString()]
											?.stats?.statsPercent ?? {},
								},
								pending:
									stats?.nodesStat[ele?.id?.toString()]
										?.pending,
								completed:
									stats?.nodesStat[ele?.id?.toString()]
										?.completed,
								orderId:
									stats?.nodesStat[ele?.id?.toString()]
										?.orderId ?? null,
								wholeApi:
									stats?.nodesStat[ele?.id?.toString()]
										?.wholeApi ?? {},
								cmsPoId:
									stats?.nodesStat[ele?.id?.toString()]
										?.cmsPoId ?? null,
							},
						};
					}),
					edges: edges?.map?.((ele) => {
						return {
							...ele,
							data: [...(stats?.edgesStat[ele?.id] ?? [])],
						};
					}),
				});
				// Fetch stats summary data
			}
		} catch (error) {
			// eslint-disable-next-line no-console
			console.error('Error:', error);
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		if (selectedStore) {
			fetchNodes();
		}
	}, [
		selectedStore,
		state?.selectedPlan,
		state?.selectedDate,
		state?.selectedTimeType,
		selectedTab,
		// productId,
		selectedBatches,
	]);

	const handleRefresh = () => {
		fetchAnalytics();
		const isRetail = stores?.find((store) => store?.id === selectedStore)?.type === 'RETAIL';
		if (isRetail) {
			setRefresh(!refresh);
		} else {
			fetchNodes();
			fetchRetailOrdersIds();
		}
	};

	useEffect(() => {
		fetchStoresList({
			entity: 'FILTERED_STORES',
			req: {
				params: {
					id: '',
					type: '',
				},
			},
			method: 'LIST',
		});
	}, []);

	const formattedDate = useMemo(() => {
		return moment(state?.selectedDate).format('YYYY-MM-DD');
	}, [state?.selectedDate]);

	async function fetchRetailOrdersIds() {
		try {
			const response = await processFlowServices.fetchRetailOrdersIds({
				data: {
					toStore: retailSelectedStore,
					store: selectedStore,
					period: {
						type: state?.selectedTimeType,
						startDate: (selectedBatches?.length > 0 && selectedBatches[0].costingDate) ? selectedBatches[0].costingDate : formattedDate,
						endDate: (selectedBatches?.length > 0 && selectedBatches[0].costingDate) ? selectedBatches[0].costingDate : formattedDate,
					},
					plan:
						state?.selectedPlan !== -1 ? state?.selectedPlan : null,
					...(!hideShift && {
						shift: (selectedBatches?.length > 0 && selectedBatches[0].shiftId) ? selectedBatches[0].shiftId : (selectedShift === -999 ? null : selectedShift),
					}),
				},
			});
			if (response?.responseCode === 'SS-001') {
				setSelectedRetailOrderStats({
					orderIds: response?.data?.poIds ?? [],
					statsSummary: {
						// API raw values bhejta hai; percent yahan compute hota hai.
						// dispatch = fulfilled, receiving = received, base = ordered.
						fulfilled: response?.data?.fulfilled ?? 0,
						ordered: response?.data?.ordered ?? 0,
						received: response?.data?.received ?? 0,
						name: response?.data?.name ?? '',
						id: response?.data?.id ?? '',
					},
				});
			}
		} catch (error) {
			// eslint-disable-next-line no-console
			console.log(error);
		}
	}
	// async function fetchShiftWiseSummary() {
	// 	try {
	// 		const response = await processFlowServices.fetchAnalyticsShiftwise({
	// 			data: {
	// 				store: selectedStore,
	// 				period: {
	// 					type: state?.selectedTimeType,
	// 					startDate: formattedDate,
	// 					endDate: formattedDate,
	// 				},
	// 				plan:
	// 					state?.selectedPlan !== -1 ? state?.selectedPlan : null,
	// 				shift: selectedShift,
	// 			},
	// 		});
	// 		if (response?.responseCode === 'SS-001') {
	// 			setBot
	// 			// response?.data?.forEach((ele) => {

	// 			// }
	// 			// shiftStats = [{	analysisType: "SOURCING", orderedCost: 13244.32, fulfilledCost: 57945.43},{analysisType: "PRODUCTION", orderedCost: 13244.32, fulfilledCost: 57945.43},{analysisType: "DISTRIBUTION", orderedCost: 13244.32, fulfilledCost: 57945.43}]

	// 		}
	// 	} catch (error) {
	// 		// eslint-disable-next-line no-console
	// 		console.log(error);
	// 	}
	// }

	useEffect(() => {
		if (!selectedStore) {
			return;
		}
		fetchRetailOrdersIds();
	}, [
		retailSelectedStore,
		selectedStore,
		state?.selectedTimeType,
		state?.selectedPlan,
		selectedShift,
		selectedShift,
		formattedDate,
	]);

	async function fetchAnalytics() {
		const nodesStat = {};
		const edgesStat = {};
		let shiftStats = [];
		if (formattedDate) {
			fetchBottomStatsSummaryData();
			// fetchShiftWiseSummary();
		}
		try {
			const response = await processFlowServices.fetchOperationAnalytics({
				data: {
					store: selectedStore,
					...(productId && { productId }),
					...(selectedBatches?.length > 0 &&
						selectedBatches[0].grnItemBatchId &&
						!selectedBatches[0].grnItemBatchId
							.toString()
							.startsWith('D') && {
						batchIds: selectedBatches.map(
							(b) => b.grnItemBatchId
						),
					}),
					period: {
						type: state?.selectedTimeType,
						startDate: (selectedBatches?.length > 0 && selectedBatches[0].costingDate) ? selectedBatches[0].costingDate : formattedDate,
						endDate: (selectedBatches?.length > 0 && selectedBatches[0].costingDate) ? selectedBatches[0].costingDate : formattedDate,
					},
					plan:
						state?.selectedPlan !== -1 ? state?.selectedPlan : null,
					...(!hideShift && {
						shift: (selectedBatches?.length > 0 && selectedBatches[0].shiftId) ? selectedBatches[0].shiftId : (selectedShift === -999 ? null : selectedShift),
					}),
					statsBy: selectedTab?.toUpperCase(),
				},
			});
			if (response?.responseCode === 'SS-001') {
				shiftStats = response?.data?.operationSummary;
				response?.data?.nodes?.forEach((ele) => {
					if (!nodesStat[ele.id]) {
						nodesStat[ele.id] = {
							wholeApi: ele,
							recipeStats: ele?.recipeStats,
							stats: {
								statsDisplay: ele?.statsDisplay,
								statsPercent: ele?.statsPercent,
							},
							orderId: ele?.poSummary,
							pending: ele?.pending,
							completed: ele?.completed,
							cmsPoId: ele?.cmsPOSummary,
						};
					}
				});
				response?.data?.edges?.forEach((ele) => {
					if (!edgesStat[ele.id]) {
						edgesStat[ele.id] = ele?.stats;
					}
				});
				if (response?.data?.productionPlans !== null) {
					setAvailableProductionPlans(
						response?.data?.productionPlans
					);
				}
			}
		} catch (error) {
			// eslint-disable-next-line no-console
			console.log(error);
		}
		return {
			nodesStat,
			edgesStat,
			shiftStats,
		};
	}

	async function fetchBottomStatsSummaryData() {
		try {
			const response = await processFlowServices.fetchAnalyticsShiftwise({
				data: {
					store: selectedStore,
					...(productId && { productId }),
					...(selectedBatches?.length > 0 &&
						selectedBatches[0].grnItemBatchId &&
						!selectedBatches[0].grnItemBatchId
							.toString()
							.startsWith('D') && {
						batchIds: selectedBatches.map(
							(b) => b.grnItemBatchId
						),
					}),
					period: {
						type: state?.selectedTimeType,
						startDate: (selectedBatches?.length > 0 && selectedBatches[0].costingDate) ? selectedBatches[0].costingDate : formattedDate,
						endDate: (selectedBatches?.length > 0 && selectedBatches[0].costingDate) ? selectedBatches[0].costingDate : formattedDate,
					},
					statsBy: selectedTab?.toUpperCase(),
				},
			});
			if (response?.responseCode === 'SS-001') {
				// const { statsSummary } = response?.data;
				// const bottomStats = statsSummary.slice(0, 3);
				setBottomDayStats(response?.data);
			}
		} catch (error) {
			// eslint-disable-next-line no-console
			console.error('Error fetching stats summary:', error);
		}
	}

	const handleNodesState = (nodes, edges) => {
		setNodesState({
			nodes,
			edges,
		});
	};

	const handleSave = async () => {
		if (!selectedStore) {
			notificationServices?.generateNotification({
				message: 'Store is not selected',
				type: 'error',
			});
			return;
		}
		try {
			const response = await processFlowServices?.saveNodes({
				data: nodesState,
				params: {
					storeId: selectedStore,
				},
			});
			if (response?.statusCode === 200) {
				setIsChanged(false);
				fetchNodes();
				toggleProcessSetting(false, {});
			}
		} catch (error) {
			// eslint-disable-next-line no-console
			console.error('Error:', error);
		}
	};

	// const handlePositionChange = (id, e) => {
	// const { name, value } = e?.target;
	// setNodesState((prev) => {
	// const temp = [...prev?.nodes];
	// const index = temp?.findIndex((ele) => {
	// return ele?.id === id;
	// });
	// temp[index].position[name] = value;
	// return {
	// nodes: temp,
	// edges: prev?.edges,
	// };
	// });
	// };

	const BASE_STORES = useMemo(() => {
		return stores?.map?.((ele) => {
			return {
				...ele,
				label: ele?.name,
				role: ele?.type,
				value: ele?.id,
			};
		});
	}, [stores]);

	const selectedStoreObj = useMemo(() => {
		return BASE_STORES?.find((ele) => ele?.id === selectedStore);
	}, [BASE_STORES, selectedStore]);

	// The store-level view (DisplayStoreView) keys off the store's TYPE, not its
	// subType: every RETAIL store gets it, not just the ones whose subType happens
	// to be DISPLAY. type and subType are orthogonal - DISPLAY is one of
	// DARK_STORE / FC / INTERNAL / DISPLAY and sits under a type - so this takes in
	// the retail stores the DISPLAY check used to leave on the process-flow view.
	const isRetailStore = selectedStoreObj?.type === 'RETAIL';

	useEffect(() => {
		if (isRetailStore) {
			setState((prev) => ({
				...prev,
				selectedDate: new Date(),
			}));
			setSelectedTab('count');
		}
	}, [isRetailStore]);

	const { baseStores, retailStores } = useMemo(() => {
		const sorted = [...BASE_STORES].sort((a, b) => {
			if (a.type === 'BASE' && b.type !== 'BASE') return -1;
			if (a.type !== 'BASE' && b.type === 'BASE') return 1;
			return 0;
		});

		const baseStores = sorted;
		const retailStores = sorted.filter((store) => store.type === 'RETAIL');

		return { baseStores, retailStores };
	}, [BASE_STORES]);

	useEffect(() => {
		if (store?.id) {
			setSelectedStore(Number(store?.id));
			return;
		}
		if (baseStores?.length > 0) {
			if (isA2bCustomer) {
				setSelectedStore(baseStores[1]?.id);
				setSelectedTab('cost');
			} else {
				setSelectedStore(baseStores[0]?.id);
			}
			setState({
				...state,
				selectedPlan: -1,
			});
		}
	}, [baseStores, store?.id]);

	useEffect(() => {
		if (date?.date) {
			setState({
				...state,
				selectedDate: new Date(date?.date),
			});
		}
	}, [date?.date]);

	useEffect(() => {
		if (retailStores?.length > 0) {
			setRetailSelectedStore(retailStores[0]?.id);
		}
	}, [retailStores]);

	const handleDateSelection = (date) => {
		setAvailableProductionPlans([]);
		setState({
			...state,
			selectedDate: date,
			selectedPlan: -1,
		});
	};

	// const handleGeneratePlan = async () => {
	// // toggleProductionPlanModal(true, {
	// // storeId: selectedStore,
	// // date: moment(state?.selectedDate).format('YYYY-MM-DD'),
	// // });
	// const req = {
	// data: {
	// storeId: selectedStore,
	// date: moment(state?.selectedDate).format('YYYY-MM-DD'),
	// },
	// };
	// setProductionPlanLoading(true);
	// try {
	// const response =
	// await inventoryAnalyticsServices.fetchProductionPlan(req);
	// if (response?.statusCode === 200) {
	// notificationServices.generateNotification({
	// type: 'success',
	// message: response?.message,
	// });
	// toggleProductionPlanModal(true, {
	// storeId: selectedStore,
	// date: moment(state?.selectedDate).format('YYYY-MM-DD'),
	// listData: response?.data,
	// });
	// } else {
	// notificationServices.generateNotification({
	// type: 'error',
	// message: response?.errorMessage ?? response?.message,
	// });
	// }
	// } catch (error) {
	// // eslint-disable-next-line no-console
	// console.log('Error In initiating Production Plan', error);
	// // notificationServices.generateNotification({
	// // type: 'error',
	// // message: 'Some Error occurred',
	// // });
	// } finally {
	// setProductionPlanLoading(false);
	// }
	// };

	const poActionHandler = async (processNode, type = 1) => {
		if (type === 1 || type === 3 || type === 4 || type === 5) {
			let key = 'orderId';
			let orders = processNode?.orderId;
			let cmsOrders = processNode?.cmsPoId;
			let heading = `Production plan of ${processNode?.heading}`;
			if (type === 3) {
				key = 'procurePoSummary';
				orders = processNode?.wholeApi[key];
				heading = `Procurement plan of ${processNode?.heading}`;
			}
			if (type === 4) {
				key = 'dispatchPoSummary';
				orders = processNode?.wholeApi[key];
				heading = `Dispatch plan of ${processNode?.heading}`;
			}
			if (type === 5) {
				key = 'outletSummary';
				orders = processNode?.tempGeneratedData?.orders;
				heading = `Outlet Summary`;
			}
			const poId = orders
				?.map?.((ele) => {
					return ele?.poId;
				})
				?.join(',');
			const cmsPoId = cmsOrders?.map?.((ele) => {
				return ele?.poId;
			});
			try {
				let fetchPromises = [];
				if (cmsPoId && cmsPoId.length > 0) {
					fetchPromises.push(
						inventoryAnalyticsServices
							?.fetchCmsPo({
								data: {
									poIds: cmsPoId,
								},
							})
							.then((response) => ({ type: 'cms', response }))
					);
				}
				if (poId) {
					fetchPromises.push(
						inventoryAnalyticsServices
							?.fetchPurchaseOrder({
								params: {
									poId,
								},
							})
							.then((response) => ({ type: 'po', response }))
					);
				}
				if (fetchPromises.length > 0) {
					let data = [];
					try {
						const results = await Promise.allSettled(fetchPromises);
						results.forEach((result) => {
							if (result.status === 'fulfilled') {
								const { type, response } = result.value;
								if (type === 'cms') {
									data = [...data, ...response?.data];
								}
								if (type === 'po') {
									data = [...data, ...response?.data?.items];
								}
							}
						});

						if (data.length > 0) {
							togglePOItemsModal(true, {
								heading,
								items: data,
								clientPoId: data[0]?.clientPoId, // Use first item's clientPoId if available
								excludedColumns: [
									'Dispatched',
									// Outlet summary (showOutletData, type 5) me Received column dikhao.
									...(type === 5 ? [] : ['Received']),
									'Returned',
									'Returned Quantity',
									'Item Price',
									'Item Sub Total',
									'Tax Percentage',
									'Item Tax',
									'Tax value',
									'Item Amount',
									'Total Item Amount',
									'Quantity',
									'Used For',
									'Discount %',
									'Last Purchase Rate 1',
									'Last Purchase Rate 2',
									'Last Purchase Rate 3',
									'Recommended Quantity',
									'Standard PO Qty',
								],
								customColumns: ['Order Type'],
								includedColumns: [],
								showOrderCount: type === 4,
							});
						}
					} catch (err) {
						console.log(err, 'err');
					}
				}
			} catch (error) {
				// eslint-disable-next-line no-console
				console.log('error', error);
			}
		} else if (type === 2) {
			setProductionPlanLoading(true);
			const poIds = processNode?.orderId?.map?.((ele) => {
				return ele?.poId;
			});
			try {
				const response = await inventoryAnalyticsServices.fetchWoPdfZip(
					{
						poIds,
					}
				);

				if (response?.statusCode === 200) {
					const blob = new Blob(
						[
							Uint8Array.from(atob(response?.data), (c) => {
								return c.charCodeAt(0);
							}),
						],
						{
							type: 'application/zip',
						}
					);
					const downloadUrl = window.URL.createObjectURL(blob);
					const hiddenElement = document.createElement('a');
					hiddenElement.href = downloadUrl;
					// eslint-disable-next-line prefer-template
					hiddenElement.download = `${processNode?.heading}_Work_order.zip`;
					document.body.appendChild(hiddenElement);
					hiddenElement.click();
					window.URL.revokeObjectURL(downloadUrl);
					document.body.removeChild(hiddenElement);
				}
			} catch (error) {
				// eslint-disable-next-line no-console
				console.log(error);
			} finally {
				setProductionPlanLoading(false);
			}
		}
	};

	const handleCancel = () => {
		fetchNodes();
		setIsChanged(false);
	};

	const nodeDelete = useCallback(
		async (id) => {
			try {
				const response = await processFlowServices.nodeDelete({
					data: {
						nodeId: id,
					},
				});
				if (response?.statusCode === 200) {
					notificationServices?.generateNotification({
						message: response?.message,
						type: 'success',
					});
					fetchNodes();
					toggleAlert(false);
				}
			} catch (error) {
				// eslint-disable-next-line no-console
				console.log('erorrr', error);
			}
		},
		[selectedStore]
	);

	const edgeDelete = async (id) => {
		try {
			const response = await processFlowServices.edgeDelete({
				data: {
					edgeId: id,
				},
			});
			if (response?.statusCode === 200) {
				notificationServices?.generateNotification({
					message: response?.message,
					type: 'success',
				});
				fetchNodes();
				toggleAlert(false);
			} else if (response?.statusCode === 404) {
				fetchNodes();
				toggleAlert(false);
			}
		} catch (error) {
			// eslint-disable-next-line no-console
			console.log('erorrr', error);
		}
	};

	const handleNodeDelete = useCallback(
		(item) => {
			toggleAlert(true, {
				heading: 'Delete Process?',
				message: `Are you sure you want to delete ${item.heading} process?`,
				handleConfirm: () => {
					nodeDelete(item?.id);
				},
			});
		},
		[selectedStore]
	);

	const handleEdgeDelete = useCallback(
		(id) => {
			toggleAlert(true, {
				heading: 'Delete Edge?',
				message: 'Are you sure you want to delete Edge?',
				handleConfirm: () => {
					edgeDelete(id);
				},
			});
		},
		[selectedStore]
	);

	const showOutletData = () => {
		const tempData = {
			orders: selectedRetailOrderStats?.orderIds?.map((ele) => {
				return {
					poId: ele,
				};
			}),
		};
		poActionHandler({ tempGeneratedData: tempData }, 5);
		// dispatch(
		// 	modalActions.toggleOutletModal(true, {
		// 		retailStoreList: retailStores,
		// 		selectedStore: retailSelectedStore,
		// 	})
		// );
	};

	// Get progress bar color based on percentage
	const getProgressBarColor = (percentage) => {
		// Check if date is today
		if (
			state?.selectedDate &&
			moment(state.selectedDate).isSame(moment(), 'day')
		) {
			return '#f59e0b'; // Yellow for today's date
		}
		// Past date - use standard color scale
		if (percentage >= 80) return '#10b981'; // Green
		if (percentage >= 50) return '#f59e0b'; // Yellow/Orange
		if (percentage >= 30) return '#f97316'; // Orange
		return '#ef4444'; // Red
	};

	const handleShiftChange = (value) => {
		setSelectedShift(value);
	};
	useEffect(() => {
		fetchNodes();
	}, [selectedShift]);

	const fulfillmentPercent = useMemo(() => {
		return Number(
			(
				bottomDayStats.reduce((acc, stat) => {
					const percent =
						stat.orderedCost > 0
							? Math.round(
								(stat.fulfilledCost / stat.orderedCost) *
								100
							)
							: 0;
					return acc + percent;
				}, 0) / (bottomDayStats.length || 1)
			)?.toFixed?.(1)
		);
	}, [bottomDayStats]);

	const outletsFulfillmentObj = useMemo(() => {
		const ordered = Number(selectedRetailOrderStats?.statsSummary?.ordered || 0);
		const fulfilled = Number(selectedRetailOrderStats?.statsSummary?.fulfilled || 0);
		const received = Number(selectedRetailOrderStats?.statsSummary?.received || 0);
		// Dispatch % = fulfilled / ordered, Receiving % = received / ordered.
		let fulfillmentPercent = ordered > 0 ? Number(((100 * fulfilled) / ordered).toFixed(1)) : 0;
		let receivingPercent = ordered > 0 ? Number(((100 * received) / ordered).toFixed(1)) : 0;
		if (isNaN(fulfillmentPercent)) fulfillmentPercent = 0;
		if (isNaN(receivingPercent)) receivingPercent = 0;
		return {
			fulfillmentPercent,
			receivingPercent,
		};
	}, [selectedRetailOrderStats]);

	// const renderQtyInfo = useCallback((stat) => {
	// 	const getQtyData = (fulfilled, ordered) => {
	// 		if (fulfilled == null || ordered == null) return null;
	// 		return { fulfilled: Math.round(Number(fulfilled) || 0), ordered: Math.round(Number(ordered) || 0) };
	// 	};
	// 	const qtyKg = getQtyData(stat?.fulfilledWeight, stat?.orderedWeight);
	// 	const qtyPcs = getQtyData(stat?.fulfilledCount, stat?.orderedCount);
	// 	if (!qtyKg && !qtyPcs) return null;
	// 	return (
	// 		<div className="flex flex-wrap gap-2 items-center w-full justify-center text-[11px]">
	// 			{qtyKg && qtyKg?.ordered > 0 && (
	// 				<span className="flex items-center gap-1 px-2 py-[2px] rounded-full bg-yellow-100 text-black">
	// 					⚖️ <b>{qtyKg.fulfilled}</b>/{qtyKg.ordered}kg
	// 				</span>
	// 			)}

	// 			{qtyPcs && qtyPcs?.ordered > 0 && (
	// 				<span className="flex items-center gap-1 px-2 py-[2px] rounded-full bg-blue-100 text-black">
	// 					📦 <b>{qtyPcs.fulfilled}</b>/{qtyPcs.ordered}pc
	// 				</span>
	// 			)}
	// 		</div>
	// 	);
	// }, []);

	const renderQtyInfo = useCallback((stat) => {
		const getQtyData = (fulfilled, fulfilledInclUnmearsured, ordered, isWeight = false) => {
			if (!ordered || ordered <= 0) return null;

			const useUnmeasured = fulfilledInclUnmearsured > 0;
			const finalFulfilled = useUnmeasured
				? fulfilledInclUnmearsured
				: fulfilled;

			if (finalFulfilled == null) return null;

			if (isWeight && ordered >= 1000) {
				return {
					fulfilled: formatQuantityWithLakhsCrores(finalFulfilled / 1000),
					ordered: formatQuantityWithLakhsCrores(ordered / 1000),
					unit: 'Ton',
					useUnmeasured: useUnmeasured,
				};
			}

			return {
				fulfilled: formatQuantityWithLakhsCrores(finalFulfilled),
				ordered: formatQuantityWithLakhsCrores(ordered),
				unit: isWeight ? 'kg' : '',
				useUnmeasured: useUnmeasured,
			};
		};

		// ORIGINAL PATH (kg)
		const qtyKg =
			stat?.orderedWeight > 0
				? getQtyData(
					stat.fulfilledWeight,
					stat.fulfilledInclUnmearsured,
					stat.orderedWeight,
					true
				)
				: null;

		// ORIGINAL PATH (pcs)
		const qtyPcs =
			stat?.orderedCount > 0
				? getQtyData(
					stat.fulfilledCount,
					stat.fulfilledInclUnmearsured,
					stat.orderedCount
				)
				: null;

		// 🔥 FALLBACK (does NOT affect existing UI)
		const qtyMain =
			!qtyKg && !qtyPcs
				? getQtyData(
					stat.fulfilled,
					stat.fulfilledInclUnmearsured,
					stat.ordered,
					selectedTab === 'weight'
				)
				: null;

		if (!qtyKg && !qtyPcs && !qtyMain) return null;

		return (
			<div className='flex flex-wrap gap-2 items-center w-full justify-center text-[11px]'>
				{qtyKg && (
					<span className='flex items-center gap-1 px-2 py-[2px] rounded-full bg-yellow-100 text-black'>
						⚖️ <b>{qtyKg?.fulfilled}</b>/{qtyKg?.ordered} {qtyKg?.unit}
					</span>
				)}

				{qtyPcs && (
					<span className='flex items-center gap-1 px-2 py-[2px] rounded-full bg-blue-100 text-black'>
						📦 <b>{qtyPcs?.fulfilled}</b>/{qtyPcs?.ordered} pc
					</span>
				)}

				{/* Uses same style – no UI disturbance */}
				{stat?.fulfilledInclUnmearsured > 0 && qtyMain && (
					<span className='flex items-center gap-1 px-2 py-[2px] rounded-full bg-gray-100 text-black text-sm'>
						<b>{qtyMain?.fulfilled}</b>/{qtyMain?.ordered} {qtyMain?.unit}
					</span>
				)}
			</div>
		);
	}, []);

	const renderQty = useCallback((stat) => {
		const getQtyData = (fulfilled, ordered) => {
			if (fulfilled == null || ordered == null) return null;
			return {
				fulfilled: Math.round(Number(fulfilled) || 0),
				ordered: Math.round(Number(ordered) || 0),
			};
		};
		const qtyKg = getQtyData(stat?.fulfilled, stat?.ordered);
		return (
			<div className='flex gap-2 items-center w-full justify-center text-[11px]'>
				{qtyKg && (
					<span className='flex items-center gap-1 px-2 py-[2px] rounded-full bg-yellow-200 text-black'>
						⚖️ <b>{qtyKg.fulfilled}</b>/{qtyKg.ordered}kg
					</span>
				)}
			</div>
		);
	}, []);

	const getIcon = (type) => {
		switch (type) {
			case 'PRODUCED':
				return produced;
			case 'SEMI_PRODUCED':
				return produced;
			case 'WASTAGE':
				return wastage;
			case 'ISSUED':
				return issued;
			case 'RESTAURANT_ISSUED':
				return restaurantIssued;
			case 'SECONDARY_PACKAGING':
				return secondaryPackaged;
			case 'PRIMARY_PACKAGING':
				return primaryPackaged;
			case 'DISPATCHED':
				return dispatched;
			default:
				return null;
		}
	};

	const handleSelectedTab = (tabId) => {
		setSelectedTab(tabId);
	};

	const handleFullMode = () => {
		setFullMode(!fullMode);
		if (!sidebarCollapsed) collapseSidebar(!sidebarCollapsed);
	};

	return (
		<div className={classes('flex flex-col w-full h-full relative', !fullMode && 'gap-3')}>
			<ProcessModal />
			<POItemsModal />
			<ProductionPlanModal />
			<ProcessSettingsDrawer />
			<OutletModal />
			<BackdropLoader
				isLoading={productionPlanLoading || loading}
				showProgress
			/>
			<EditNodeModal
				storeId={selectedStore}
				immovableAssetsList={immovableAssetsList}
				fetchNodes={fetchNodes}
				stores={BASE_STORES}
			/>
			<AlertModal />
			<ImageModal />
			<CustomModal />
			{/* Note Badge - Work Orders */}
			{(state?.selectedTimeType === 'WORK_ORDER') && (
				<div className='flex items-center gap-3 px-4 py-2 bg-gradient-to-r from-amber-50/80 to-transparent border-l-4 border-amber-400/60 rounded-r-lg w-fit mt-1  mx-4 transition-all duration-300 hover:from-amber-100/80'>
					<span className='text-[12px] text-gray-600 font-medium flex items-center gap-1.5'>
						<span className='w-1.5 h-1.5 rounded-full bg-amber-500 shadow-[0_0_8px_rgba(245,158,11,0.4)]' />
						Note: Data is being displayed based on its <span className='text-amber-700 font-bold'>Scheduled At</span> date context.
					</span>
				</div>
			)}

			{/* first contatiner */}
			{!fullMode && (
				<div className='flex flex-col gap-3 items-start p-4 border-b border-slate-400'>
					<div className='flex items-center gap-2 md:gap-4 w-full flex-wrap'>
						<span className='font-semibold text-base whitespace-nowrap'>
							Live Operations
						</span>
						<SelectPicker
							data={baseStores}
							groupBy='type'
							className='flex-1'
							placeholder='Select Store'
							cleanable={false}
							onChange={(storeId) => {
								setSelectedStore(storeId);
								setState({
									...state,
									selectedPlan: -1,
								});
								setViewType('STORE');
							}}
							menuStyle={{
								zIndex: 10000,
							}}
							renderMenuItem={(_) => {
								return (
									<div>
										<i className='rs-icon rs-icon-user' /> {_}
									</div>
								);
							}}
							renderMenuGroup={(_) => {
								return (
									<div>
										<i className='rs-icon rs-icon-group' />
										{_}
									</div>
								);
							}}
							value={selectedStore}
							renderValue={(value, item) => {
								return (
									<div className='rsuite-select-picker-render-value'>
										{item?.name}
									</div>
								);
							}}
						/>
						{selectedStoreObj?.type === 'BASE' && (
							<div className='flex rounded-md shadow-sm border border-gray-300' role='group'>
								<button
									type='button'
									onClick={() => setViewType('STORE')}
									className={`px-4 py-2 text-sm font-medium rounded-r-md transition-colors ${viewType === 'STORE'
										? 'bg-blue-600 text-white border-blue-600 z-10'
										: 'bg-white text-gray-700 hover:bg-gray-50'
										}`}
								>
									Store Level
								</button>
								<button
									type='button'
									onClick={() => setViewType('PROCESS')}
									className={`px-4 py-2 text-sm font-medium border-r border-gray-300 rounded-l-md transition-colors ${viewType === 'PROCESS'
										? 'bg-blue-600 text-white border-blue-600 z-10'
										: 'bg-white text-gray-700 hover:bg-gray-50'
										}`}
								>
									Section Stock
								</button>
							</div>
						)}
						{/* {availableProductionPlans?.length > 1 && (
						<TextField
							select
							value={state?.selectedPlan}
							label='Select Production plan'
							onChange={(e) => {
								setState({
									...state,
									selectedPlan: e?.target?.value,
								});
							}}
							className='flex-1'
							style={{
								background: '#fff',
							}}
						>
							<MenuItem value={-1}>All</MenuItem>
							{availableProductionPlans?.map?.((ele) => {
								return (
									<MenuItem value={ele?.id}>
										{ele?.description} (ID:
										{ele?.id})
									</MenuItem>
								);
							})}
						</TextField>
					)} */}
						{/* <SelectPicker
						data={[
							{
								label: 'Work Order On',
								value: 'WORK_ORDER',
							},
							{
								label: 'Production Plan Generated for',
								value: 'PRODUCTION_PLAN',
							},
						]}
						value={state?.selectedTimeType}
						searchable={false}
						cleanable={false}
						onChange={(value) => {
							setState({
								...state,
								selectedTimeType: value,
							});
						}}
						className='flex-1'
						placeholder='Select Date Type'
					/> */}
						<DatePicker
							oneTap
							format='dd MMM yy'
							placeholder='Select Date'
							value={state?.selectedDate}
							onChange={handleDateSelection}
							className='flex-1'
							cleanable={false}
							placement='bottomStart'
							disabled={isRetailStore || isProductJourneyActive}
						/>
						{!hideShift && (
							<SelectPicker
								disabled={isRetailStore}
								data={shiftList?.map?.((ele) => {
									return {
										label: ele?.shiftName,
										value: ele?.id,
									};
								})}
								value={selectedShift}
								onChange={handleShiftChange}
								placeholder='Select Shift'
								cleanable={false}
								className='flex-1'
								renderValue={(value, item) => item?.label}
							/>
						)}
						<div className='inline-flex rounded-md bg-yellow-50 border-2 border-yellow-400'>
							{tabs?.map?.((tab) => (
								<button
									key={tab?.id}
									onClick={() => handleSelectedTab(tab?.id)}
									className={`px-3.5 py-2 flex items-center text-sm font-medium rounded-md whitespace-nowrap ${selectedTab === tab?.id
										? 'bg-yellow-200 text-black'
										: 'text-gray-700 hover:bg-yellow-200/50'
										}`}
								>
									<span className='mr-1'>{tab?.icon}</span>
									{tab?.label}
								</button>
							))}
						</div>
						<RefreshCcw size={20} onClick={handleRefresh} className={`cursor-pointer ${loading ? 'opacity-50 animate-spin cursor-not-allowed' : ''}`} />
					</div>
					{selectedTab === 'count' && (
						<p className='text-orange-500 text-sm justify-end w-full flex'>
							This data is shown only for countable items
						</p>
					)}
					{/* Progress Cards */}
					<div className='flex gap-2 flex-wrap w-full'>
						{upperShiftStats?.map?.((stat, index) => {
							const name =
								stat?.name ??
								upperShiftWiseStatsName[stat.analysisType];

							// 🔹 Base numbers
							const orderedRaw = stat?.ordered || 0;
							const fulfilledRaw = stat?.fulfilled || 0;

							// 🔹 Percent stays NUMERIC
							const percent =
								orderedRaw > 0
									? Math.round((fulfilledRaw / orderedRaw) * 100)
									: 0;

							// 🔹 Custom qty (unchanged)
							const renderWeightInfo = renderQtyInfo(stat);

							// 🔹 Display values (ONLY formatting changes)
							let displayAmount;
							let ordered;

							if (selectedTab === 'cost') {
								displayAmount = `₹${formatQuantityWithLakhsCrores(
									fulfilledRaw
								)}`;
								ordered = formatQuantityWithLakhsCrores(orderedRaw);
							} else if (selectedTab === 'weight') {
								const formatWeightVal = (raw) => {
									if (raw >= 1000) {
										return `${formatQuantityWithLakhsCrores(raw / 1000)} Ton`;
									}
									return `${formatQuantityWithLakhsCrores(raw)} Kg`;
								};
								displayAmount = formatWeightVal(fulfilledRaw);
								ordered = formatWeightVal(orderedRaw);
							} else {
								displayAmount =
									formatQuantityWithLakhsCrores(fulfilledRaw);
								ordered = formatQuantityWithLakhsCrores(orderedRaw);
							}

							return (
								<ProgressCard
									key={index}
									label={name}
									percent={percent}
									amount={displayAmount}
									color={getProgressBarColor(percent)}
									icon={getIcon(stat.analysisType)}
									iconClassName={stat.analysisType === 'DISPATCHED' ? '-scale-x-100' : ''}
									renderCustomQty={renderWeightInfo || null}
									renderOutOf={ordered}
									redirection={{
										url: ![68, '68'].includes(
											appConfig?.customerId
										)
											? `${urls?.EXTENSION}${urls?.AIFMS_SUMMARY_DYNAMIC
											}?parentValue=${stat.analysisType ===
												'SEMI_PRODUCED'
												? 'PRODUCED'
												: stat?.analysisType
											}&dateRange=${encodeURIComponent(
												JSON.stringify({
													active: true,
													from: state?.selectedDate,
													to: state?.selectedDate,
												})
											)}&timeType=${encodeURIComponent(
												JSON.stringify({
													value: 'scheduledAt',
													label: 'Scheduled At',
												})
											)}`
											: `${urls?.EXTENSION}${urls?.AI_FMS_PAGE
											}?parentValue=${isA2bCustomer
												? stat.analysisType ===
													'PRIMARY_PACKAGING'
													? 'PRODUCED'
													: stat?.analysisType
												: stat.analysisType
											}&dateRange=${encodeURIComponent(
												JSON.stringify({
													active: true,
													from: state?.selectedDate,
													to: state?.selectedDate,
												})
											)}&mealTypeId=${shiftList?.find(
												(ele) =>
													ele?.id ===
													selectedShift
											)?.id
											}`,
									}}
								/>
							);
						})}
					</div>
				</div>
			)}
			{/* middle container  */}

			{isRetailStore ||
				(selectedStoreObj?.type === 'BASE' && viewType === 'PROCESS') ? (
				<DisplayStoreView
					selectedStore={selectedStore}
					selectedDate={state?.selectedDate}
					refresh={refresh}
					viewTypeProcess={selectedStoreObj?.type === 'BASE' && viewType === 'PROCESS'}
				/>
			) : (
				<>
					<ProcessFlowMiddleContainer
						retailStores={retailStores}
						retailSelectedStore={retailSelectedStore}
						setRetailSelectedStore={setRetailSelectedStore}
						outletsFulfillmentObj={outletsFulfillmentObj}
						getProgressBarColor={getProgressBarColor}
						selectedRetailOrderStats={selectedRetailOrderStats}
						showOutletData={showOutletData}
						toggleProcessModal={toggleProcessModal}
						isInternal={isInternal}
						isEdit={isEdit}
						initialState={initialState}
						handleNodesState={handleNodesState}
						poActionHandler={poActionHandler}
						setIsChanged={setIsChanged}
						toggleImageModal={toggleImageModal}
						toggleEditNodeModal={toggleEditNodeModal}
						toggleAlert={toggleAlert}
						handleEdgeDelete={handleEdgeDelete}
						handleNodeDelete={handleNodeDelete}
						selectedStore={selectedStore}
						state={state}
						level={level}
						toggleProcessSetting={toggleProcessSetting}
						BASE_STORES={BASE_STORES}
						setInitialState={setInitialState}
						isChanged={isChanged}
						immovableAssetsList={immovableAssetsList}
						handleCancel={handleCancel}
						handleSave={handleSave}
						setProductId={setProductId}
						handleFullMode={handleFullMode}
						fullMode={fullMode}
						selectedBatches={selectedBatches}
						setSelectedBatches={setSelectedBatches}
						setState={setState}
						setSelectedShift={setSelectedShift}
						setIsProductJourneyActive={setIsProductJourneyActive}
					/>

					{/* third container */}
					{!fullMode && (
						<div className='flex w-full items-center border border-slate-400  gap-4 bg-white shadow-sm'>
							{/* Left: Circular Progress */}
							<div className='flex items-center gap-4 h-full border-r border-slate-400 p-3 w-[14%]'>
								<div className='flex flex-col items-center'>
									<span className='text-[11px] text-gray-500'>
										Order Fulfillment
									</span>
									<Button
										className='mt-1 p-[12px] text-[12px] text-gray-700 bg-gray-100 border border-gray-300 rounded-md hover:bg-gray-200 transition'
										onClick={() => {
											const dateRange = encodeURIComponent(
												JSON.stringify({
													active: true,
													from: state?.selectedDate,
													to: state?.selectedDate,
												})
											);
											const store = encodeURIComponent(
												JSON.stringify({
													id: selectedStore,
													name: '',
												})
											);
											const url = `${urls?.EXTENSION}${urls?.FMS_ORDERS_LIST}?dateRange=${dateRange}&store=${store}`;
											window.open(url, '_blank');
										}}
									>
										View more
									</Button>
								</div>
								<div className='flex items-center justify-center'>
									<Progress.Circle
										percent={Math.floor(fulfillmentPercent)}
										strokeColor={getProgressBarColor(
											Math.floor(fulfillmentPercent)
										)}
										strokeWidth={8}
										trailWidth={8}
										style={{
											width: 50,
											height: 50,
											fontSize: '10px',
										}}
									/>
								</div>
							</div>

							{/* Center: Plan Info */}
							<div className='flex flex-col px-2 w-[86%]'>
								<div className='flex items-center gap-2 mb-1'>
									<span className='text-[11px] text-gray-500'>
										Production Plan (Issued):
									</span>
									{/* <span className='font-semibold text-[13px]'>
							DailyPlan#20230725
						</span> */}
									<span className='text-[11px] text-gray-500'>
										({fulfillmentPercent}%)
									</span>
								</div>
								<div className='flex gap-3 w-full items-center'>
									{bottomDayStats?.map?.((stat, index) => {
										const percent =
											stat?.ordered > 0
												? Math.round(
													(stat?.fulfilled /
														stat?.ordered) *
													100
												)
												: 0;
										const fulfilledValue = Number(
											stat?.fulfilled
										);
										const fulfilledCost =
											selectedTab === 'count'
												? Number.isFinite(fulfilledValue)
													? fulfilledValue.toFixed(2)
													: stat?.fulfilled
												: addCommas(
													stat?.fulfilled,
													'IN',
													true
												);

										return (
											<ProgressCard
												key={index}
												label={stat.name}
												percent={percent}
												renderCustomQty={
													selectedTab === 'weight'
														? renderQty(stat)
														: null
												}
												amount={fulfilledCost}
												color={getProgressBarColor(percent)}
											/>
										);
									})}
									{/* <Button className="p-[12px] text-black text-[11px] bg-gray-100 border border-gray-300 rounded-md hover:bg-gray-200 transition">
      		View more
   		</Button> */}
								</div>
							</div>
						</div>
					)}
				</>
			)}
		</div>
	);
}

const mapStateToProps = (state) => {
	const { userPermissions, sidebarCollapsed } = state.navigation;
	// const stores = state?.form?.STORES?.data?.LIST;
	const stores = state?.form?.FILTERED_STORES?.data?.LIST;

	return {
		stores,
		userPermissions,
		sidebarCollapsed,
	};
};
const mapDispatchToProps = {
	toggleProcessModal: modalActions?.toggleProcessModal,
	toggleProductionPlanModal: modalActions?.toggleProductionPlanModal,
	togglePOItemsModal: modalActions?.togglePOItemsModal,
	fetchStoresList: formActions.gateway,
	toggleProcessSetting: drawerActions.toggleProcessSettingsDrawer,
	toggleImageModal: modalActions.toggleImageModal,
	toggleEditNodeModal: modalActions.toggleEditNodeModal,
	toggleAlert: modalActions.toggleAlert,
	collapseSidebar: navigationActions.collapseSidebar,
};

export default connect(mapStateToProps, mapDispatchToProps)(ProcessFlowPage);
